import { useTranslation } from 'react-i18next';
import DustPolicyCard from '../../components/settings/dust-policy-card.tsx';
import { SettingsLeafPage } from '../../components/settings/settings-leaf-page.tsx';

/** Settings › Pricing & quotes › Dust evidence: only this card, so only its reads run. */
export default function PricingDustPage() {
  const { t } = useTranslation();
  return (
    <SettingsLeafPage
      title={t('settings.pricingPages.tiles.dust.title')}
      back={{ to: '/settings/pricing', label: t('settings.pricingPages.backToPricing') }}
    >
      <DustPolicyCard />
    </SettingsLeafPage>
  );
}
